import { FormTable, FormTableBody, InformationCircleIcon } from "@porchpass/ui";

export default () => (
  <FormTable
    title="Disclaimer"
    headerIcon={
      <InformationCircleIcon
        variant="bulk-rounded"
        size={16}
        className="text-[#6F41E6]"
      />
    }
  >
    <FormTableBody className="text-sm leading-5 text-[#4a5466]">
      <p>
        The purpose of collecting this information is to help ensure that all
        applicants are treated fairly and that the housing needs of communities
        and neighborhoods are being fulfilled. For residential mortgage lending,
        federal law requires that we ask applicants for their demographic
        information (ethnicity, sex and race) in order to monitor our compliance
        with equal opportunity, fair housing and home mortgage disclosure laws.
        You are not required to provide this information, but you are encouraged
        to do so. You may select one or more designations for “Ethnicity” and
        one or more designations for “Race.” The law provides that we may not
        discriminate on the basis of this information or on whether you choose
        to provide it. If you do not wish to provide some or all of this
        information, please select that option above.
      </p>
    </FormTableBody>
  </FormTable>
);
